import * as classes from './Footer.module.css'

const Footer = ({ copyright, terms, privacy }) => {
  return (
    <footer className={`container ${classes.footer}`}>
      <div className={`container-sm`}>
        <div className={`container-text ${classes.footerContent}`}>
          {copyright && <div className={classes.left}>{copyright}</div>}
          <div className={classes.right}>
            {terms && <a href={terms.fields?.url} target={terms.fields?.target}>
              {terms.fields?.title}
            </a>}
            {privacy && <a href={privacy.fields?.url} target={privacy.fields?.target}>
              {privacy.fields?.title}
            </a>}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
